<script module lang="ts">
	export enum TabVariant {
		LightBackground,
		DarkBackground
	}
</script>

<script lang="ts">
	interface Props {
		isSelected?: boolean
		tabName?: string
		variant?: TabVariant
		onclick?: (() => void) | null
	}

	let {
		isSelected = false,
		tabName = '',
		variant = TabVariant.LightBackground,
		onclick = null
	}: Props = $props()

	function onClick(): void {
		onclick?.()
	}
</script>

<button onclick={onClick} class="tab-button {isSelected ? 'tab-selected' : 'tab-unselected'}">
	<span class="tab-label {isSelected ? 'selected-text' : 'unselected-text'}">
		{tabName}
	</span>
</button>

<style>
	.tab-button {
		@apply h-12 px-4 justify-start items-center gap-2 inline-flex;

		&:hover .unselected-text {
			@apply text-[#001526];
		}
	}
	.tab-selected {
		@apply border-b-4 border-[#007acc];
	}
	.tab-unselected {
		@apply border-b-4 border-transparent;
	}
	.tab-label {
		@apply text-center text-base leading-normal;
	}
	.selected-text {
		@apply text-[#007acc] font-semibold;
	}
	.unselected-text {
		@apply text-[#001D33B2] font-normal transition-colors;
	}
</style>
